// MARK: NPM modules
import React from "react";
import styled from "styled-components";

// MARK: Styled Components
interface ImageProps {
  height?: string;
  backgroundcolor?: string;
  borderradius?: number;
}

const Image = styled.img<ImageProps>`
  min-width: 100%;
  width: 100%;
  height: 100%;
  min-height: 100%;
  object-fit: cover;
  background-color: ${({ backgroundcolor }) =>
    backgroundcolor ? backgroundcolor : 0};
  border-radius: ${({ borderradius }) => (borderradius ? borderradius : 0)}px;
`;

export default Image;
